import React from 'react';
import {Table} from 'semantic-ui-react';

export default class WasteTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <Table.Row>
                <Table.Cell>{this.props.data.wasteStream}</Table.Cell>
                <Table.Cell>{this.props.data.wasteContainer}</Table.Cell>
                <Table.Cell>{this.props.data.weightQuantity}</Table.Cell>
                <Table.Cell>{this.props.data.wasteDestination}</Table.Cell>
                <Table.Cell>{this.props.data.wastePeriod}</Table.Cell>
                <Table.Cell>{this.props.data.submissionDate}</Table.Cell>
             
            </Table.Row>
        );
    }

    componentDidMount = () => {
        this.fetchData();
    }

    fetchData = () => {

    }

    componentDidUpdate = () => {

    }
}